import { makeStyles } from '@material-ui/core';
export const styleOptionsList = makeStyles((theme) => ({
    listbox: {
        boxSizing: 'border-box',
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
}));
